import { Recurso } from "lib.common/dist/CleanArch";
import { ConciliacionDtSource } from "../../bussines/dataSources/ConciliacionDtSource";
import { AbonoPasarela } from "../../bussines/entities/AbonoPasarela";
import { GetSomeConciliacionParams } from "../../utils/params/GetSomeConciliacionParams";
import { format } from "date-fns";
import { transformacion } from "lib.common/dist";
import { apiDsTienda } from "src/config/keys";
import { ErrExterno } from "lib.common/dist/errorHandler";

export class ConciliacionDtSourceImplRest implements ConciliacionDtSource {
    async getSomeConciliacion(input: GetSomeConciliacionParams): Promise<Recurso<AbonoPasarela[]>> {
        try {
            const { fechaIni, fechaFin } = input;
            let url = transformacion.appendUrl(apiDsTienda, '/gestionPagos/abono/ListarAbonosPasarela');
            const params = new URLSearchParams();
            if (fechaIni) params.append('pFechaInicial', format(fechaIni, 'yyyy-MM-dd'));
            if (fechaFin) params.append('pFechaFinal', format(fechaFin, 'yyyy-MM-dd'));
            url.search = params.toString();
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || 'Error en la petición de conciliaciones en tienda.');
            }
            const { data } = await response.json();
            return Recurso.fromData<AbonoPasarela[]>(data);
        } catch (error) {
            return Recurso.fromError<AbonoPasarela[]>(new ErrExterno(error as Error));
        }
    }
}